import styles from '@/styles/Radio.module.scss'
import React, { Fragment } from 'react'

type RadioProps = {
  htmlfor: string
  register: any
  formValueSplit?: any
  required?: any
}

const Radio = ({ htmlfor, register, formValueSplit, required }: RadioProps) => {
  return (
    <>
      {formValueSplit.map((radio: string, i) => {
        return (
          <Fragment key={i}>
            <label className={'mt-3 flex cursor-pointer items-center'}>
              <input
                className={`${styles.c_radio_input}`}
                id={htmlfor}
                name={htmlfor}
                type="radio"
                value={`${radio}`}
                {...register(htmlfor, {
                  required,
                })}
              />
              <span className={`${styles.c_radio_dummyInput}`} />
              <span className="ml-2 flex-1 text-sm">{radio}</span>
            </label>
          </Fragment>
        )
      })}
    </>
  )
}

export default Radio
